<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeProduitNonCom.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeProduitNonCom.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12">
        <b-field :label="$t('listeProduitNonCom.filtre.motifNonCommercialisation')">
          <qd-taginput
            v-if="motifNonComTags"
            v-model="motifsNonComSelected"
            :data="motifNonComTags"
            @typing="getFilteredMotifNonComTags"
            @input="getMotifNonComTag"
            type="is-primary"
            icon="magnify"
            field="libelle"
            autocomplete
            open-on-focus>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeProduitNonCom.filtre.categorie')"
                      :items="categorieProduit"
                      v-model="categoriesSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeProduitNonCom.filtre.actif')">
          <b-select v-model="critereRecherche.actif">
            <option :value="null"></option>
            <option :value="true"> {{ $t('listeProduitNonCom.filtre.yes') }}
            </option>
            <option :value="false"> {{ $t('listeProduitNonCom.filtre.no') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeProduitNonCom.filtre.agence')"
                      :items="filtrerProduitParAgence ? agencesSelectionnees : agencesInformations"
                      v-model="critereRecherche.agencesId">
        </agence-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
      && !filtrerProduitParSociete && !filtrerProduitParAgence">
        <b-field :label="$t('listeProduitNonCom.filtre.societe')">
          <b-select v-model="critereRecherche.societeId" expanded>
            <option :value="null"></option>
            <option v-for="societe in societesInformations"
                    :key="societe.id"
                    :value="societe.id">
              {{ societe.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeProduitNonCom.filtre.actions.appliquer')}}`
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeProduitNonCom.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheCatalogueProduitNonCom';
import { SET_CRITERE_RECHERCHE_PRODUIT_NON_COM } from '@/store/modules/produit-mutation-type';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';

const Societe = createNamespacedHelpers('societe');
const Produit = createNamespacedHelpers('produit');
const Parametres = createNamespacedHelpers('parametres');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  data() {
    return {
      critereRecherche: null,
      listeMotifNonComBase: [],
      motifsNonComSelected: [],
      motifNonComTags: null,
      categoriesSelected: [],
    };
  },
  components: {
    libelleTagInput,
    agenceTagInput,
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Produit.mapGetters({
      criteresRechercheFromStore: 'criteresRechercheProduitNonCom',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    motifsNonCom() {
      return this.parametre(PARAMETRES_KEYS.faceMotifNonCom).filter(motif => motif.actif);
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
  },
  methods: {
    ...Produit.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE_PRODUIT_NON_COM,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRecherche());
      this.motifsNonComSelected = [];
      this.categoriesSelected = [];
      this.getMotifNonComTag();
    },
    appliquerCritere() {
      this.critereRecherche.motifNonCommercialisableIds = this.motifsNonComSelected.map(m => {
        return m.id;
      });
      this.critereRecherche.categorie = this.categoriesSelected.map(c => { return c.code; });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getFilteredMotifNonComTags(text) {
      this.getMotifNonComTag();
      this.motifNonComTags = this.motifNonComTags.filter((motifNonCom) => {
        return motifNonCom.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getMotifNonComTag() {
      this.motifNonComTags = this.listeMotifNonComBase.filter((motifNonCom) => {
        return !this.motifsNonComSelected.map(a => a.id).includes(motifNonCom.id);
      });
    },
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([PARAMETRES_KEYS.faceMotifNonCom]);
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
          PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key]);
        this.listeMotifNonComBase = this.motifsNonCom;
        this.motifsNonComSelected = this.listeMotifNonComBase.filter((motif) => {
          return this.critereRecherche.motifNonCommercialisableIds.includes(motif.id);
        });
        this.getMotifNonComTag();
        this.categoriesSelected = this.categorieProduit.filter((categorie) => {
          return this.critereRecherche.categorie.includes(categorie.code);
        });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
